import { Button, Form } from 'antd';
import { FormInput } from 'presentation/components/form/FormInput.component';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import getMessage from 'utilities/constants/MESSAGE';
import { PLACEHOLDER } from 'utilities/constants/PLACEHOLDER';
import { CONSTANTS } from 'utilities/constants/SIMULATE';

type props = {
    form: any;
    getData: (value: any) => void;
    saveData: () => void;
    getCollapseProps: () => any;
    btnDisable: boolean;
    setBtnDisable: (value: boolean) => void;
};

const FormSimulateSale = ({
    form,
    getData,
    saveData,
    getCollapseProps,
    btnDisable,
    setBtnDisable,
}: props) => {
    const navigate = useNavigate();

    const onChangeForm = () => {
        if (
            Object.values(form.getFieldsValue()).some(
                (item: any) => item === undefined || item === '',
            )
        )
            setBtnDisable(true);
        else setBtnDisable(false);
    };

    const scrollTop = () => {
        document.getElementById('top-page')?.scrollIntoView({ behavior: 'smooth' });
    };

    React.useEffect(() => {
        scrollTop();
    }, []);

    const onSubmit = async (values: any) => {
        getData(values);
    };

    const itemRules = {
        annualIncome: [
            {
                required: true,
                message: getMessage('In_Required', '年収'),
            },
        ],
        existingLoanAmount: [
            {
                required: true,
                message: getMessage('In_Required', '既存借入額'),
            },
        ],
    };

    return (
        <div className="section-wrapper">
            <div className="simulate-form">
                <Form form={form} onFinish={onSubmit} onChange={onChangeForm}>
                    <div {...getCollapseProps()}>
                        <div className="simulate-form-item">
                            <div className="simulate-form-input">
                                <FormInput
                                    placeholder={PLACEHOLDER.ANNUAL_INCOME}
                                    type="number"
                                    suffix={'円'}
                                    style={{
                                        width: CONSTANTS.INPUT_WIDTH,
                                        height: CONSTANTS.INPUT_HEIGHT,
                                        border: CONSTANTS.INPUT_BORDER,
                                        color: '#000',
                                        fontSize: 14,
                                    }}
                                    name="annualIncome"
                                    maxLength={9}
                                    min={0}
                                    rules={itemRules.annualIncome}
                                    label="年収"
                                />
                            </div>
                            <div className="simulate-form-input">
                                <FormInput
                                    placeholder={PLACEHOLDER.EXISTING_LOAN_AMOUNT}
                                    suffix={'円'}
                                    type="number"
                                    style={{
                                        width: CONSTANTS.INPUT_WIDTH,
                                        height: CONSTANTS.INPUT_HEIGHT,
                                        border: CONSTANTS.INPUT_BORDER,
                                        color: '#000',
                                        fontSize: 14,
                                    }}
                                    name="existingLoanAmount"
                                    maxLength={9}
                                    min={0}
                                    rules={itemRules.existingLoanAmount}
                                    label="既存借入額"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="simulate-form-item">
                        <div className="simulate-form-option" onClick={() => form.submit()}>
                            再実行
                        </div>
                        <Button
                            type="primary"
                            disabled={btnDisable}
                            className="simulate-form-option"
                            style={{
                                background: '#4BCAE5',
                                color: '#fff',
                                cursor: `${btnDisable ? 'not-allowed' : 'pointer'}`,
                            }}
                            onClick={() => (!btnDisable ? saveData() : null)}
                        >
                            実行結果を保存
                        </Button>
                    </div>
                    <div className="simulate-form-item">
                        <div
                            className="simulate-form-button"
                            style={{ backgroundColor: '#1F8DDD' }}
                            onClick={() =>
                                navigate(`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_002_01}`)
                            }
                        >
                            出品中物件リストへ
                        </div>
                    </div>
                </Form>
            </div>
        </div>
    );
};

export default FormSimulateSale;
